import { Component, OnInit, ElementRef, ChangeDetectionStrategy, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { FormHelpers } from '@asamco/utils';
import { DxTextBoxModule, DxLookupModule, DxDateBoxModule, DxTextAreaModule } from 'devextreme-angular';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { AsValidatorDirective } from '@asamco/base';
import { DropDownDatasourceRow, JsonEditorModalComponent, MultiselectDropdownComponent, WarningModalContext, WarningModalMessage, WarningModalMessageHelper } from '@asamco/application-link/shared';

declare var window: any;
@Component({
    templateUrl: './warning-modal-message-create-modal.component.html',
    selector: 'warning-modal-message-create-modal',
    styleUrls: ['warning-modal-message-create-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        DxTextBoxModule,
		DxTextAreaModule,
        AsValidatorDirective,
        DxLookupModule,
        DxDateBoxModule,
        NgFor,
        AsyncPipe,
		MultiselectDropdownComponent,
		JsonEditorModalComponent
    ],
})
export class WarningModalMessageCreateModalComponent implements OnInit {
	@Output()
	showToast = new EventEmitter<string>();

	@ViewChild(JsonEditorModalComponent)
	jsonEditorModal: JsonEditorModalComponent;

	selectableFromLinkTemplates: DropDownDatasourceRow[];
	selectableToLinkTemplates: DropDownDatasourceRow[];

	contexts = WarningModalMessageHelper.Contexts;

	visible$ = new BehaviorSubject<boolean>(false);

	form;

	private subject: Subject<WarningModalMessage>;

	constructor(public el: ElementRef, public fb: FormBuilder) {
	}

	ngOnInit() {
		this.initForm();
	}

	hide() {
		this.visible$.next(false);
	}

	show(message?: WarningModalMessage) {
		let fromLinkTemplateIds = message?.fromLinkTemplateIds?.split(',') || [];
		fromLinkTemplateIds = fromLinkTemplateIds?.slice(1,fromLinkTemplateIds.length - 1);
		for(const flt of this.selectableFromLinkTemplates) flt.selected = fromLinkTemplateIds.some(id => flt.id === +id);
		let toLinkTemplateIds = message?.toLinkTemplateIds?.split(',') || [];
		toLinkTemplateIds = toLinkTemplateIds?.slice(1,toLinkTemplateIds.length - 1);
		for(const tlt of this.selectableToLinkTemplates) tlt.selected = toLinkTemplateIds.some(id => tlt.id === +id);

		if(message) {
			const formValue = <any>Object.assign({}, message);
			delete formValue.fromLinkTemplates;
			delete formValue.toLinkTemplates;
			this.form.setValue(formValue);
		} else {
			this.initForm();
		}

		this.visible$.next(true);
		this.subject = new Subject<WarningModalMessage>();
		return this.subject;
	}

	ok() {
		if (FormHelpers.validateForm(this.form)) {
			const formValue = this.form.value;
			formValue.fromLinkTemplateIds = `,${this.selectableFromLinkTemplates.filter(lt => lt.selected).map(lt => lt.id).join(',')},`;
			formValue.toLinkTemplateIds = `,${this.selectableToLinkTemplates.filter(lt => lt.selected).map(lt => lt.id).join(',')},`;
			this.subject.next(formValue);
			this.visible$.next(false);
		}
	}

	cancel() {
		this.hide();
		this.subject.complete();
	}

	private initForm() {
		this.form = this.fb.group({
			id: new FormControl(0),
			name: new FormControl('New Message', Validators.required),
			context: new FormControl(WarningModalContext.EnterCsp, Validators.required),
			fromLinkTemplateIds: new FormControl(null),
			toLinkTemplateIds: new FormControl(null),
			height: new FormControl('400px'),
			width: new FormControl('400px'),
			startDate: new FormControl(null),
			endDate: new FormControl(null),
			messageHtml: new FormControl('', Validators.required)
		});
	}

	viewTranslations() {
		const selectedContext = this.contexts.find(c => c.id === this.form.controls.context.value);
		this.jsonEditorModal.showAndAwait(selectedContext.translations);
	}
}
